// ============================================================================
// HOOK: useCurrentUser — Estado reativo do usuário autenticado
// ARQUIVO: src/hooks/useCurrentUser.js
// RESPONSABILIDADE: Eliminar race condition de auth.currentUser.
//   Sempre consumir user do estado reativo, nunca do objeto síncrono.
// ============================================================================

import { useEffect, useState, useCallback } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../shared/api/firebase/config';

export function useCurrentUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  const getToken = useCallback(async (forceRefresh = false) => {
    if (!user) return null;
    return user.getIdToken(forceRefresh);
  }, [user]);

  return {
    user,
    uid: user?.uid || null,
    email: user?.email || null,
    displayName: user?.displayName || null,
    photoURL: user?.photoURL || null,
    emailVerified: user?.emailVerified || false,
    isAdmin: user?.email?.endsWith('@rodrigodemeterco.adv.br') || false,
    getToken,
    loading,
  };
}

export default useCurrentUser;
